const SET_AUTH_DATA = '@home/set-auth-data';

export {SET_AUTH_DATA};
